<template>
  <v-container fluid no-gutters class="pa-0 d-flex flex-column" style="height: 100%">
    <navbar-panel>
      <template #[`content.prepend`]>
        <v-col v-if="isOzeProjectFilterSelectorVisible" cols="auto" class="tw:ml-5">
          <oze-project-filter-selector />
        </v-col>
        <v-col cols="auto" class="border-left ml-5" style="height: 25px" />
        <v-col cols="12" class="flex-shrink-1 pl-3">
          <the-navbar-top-panel />
        </v-col>
      </template>
    </navbar-panel>
    <the-navbar-tools-panel />
  </v-container>
</template>

<script>
import NavbarPanel from '@/components/NavbarPanel';
import TheNavbarToolsPanel from '@/components/TheNavbarToolsPanel';
import TheNavbarTopPanel from '@/components/TheNavbarTopPanel';
import OzeProjectFilterSelector from '@/components/OzeProjectFilterSelector';

export default {
  name: 'TheNavbar',
  components: { NavbarPanel, TheNavbarToolsPanel, TheNavbarTopPanel, OzeProjectFilterSelector },
  computed: {
    isOzeProjectFilterSelectorVisible() {
      return this.$store.get('admin/isPermitted', { module: 'OZE_MODULE', setting: 'oze_module_enabled' });
    },
  },
};
</script>

<style lang="scss" scoped>
.border-left {
  @include border(left);
}
</style>
